import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { routeLoaders } from './Roter';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root') as HTMLElement;

const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

const mount = () => ReactDOM.createRoot(container).render(app);

// Indexable routes are shipped pre-rendered (scripts/prerender.js) as a paint
// shell, so the page is on screen long before this bundle runs.
//
// It is deliberately NOT hydrated: the snapshot comes from a browser render,
// which does not reproduce the markup hydrateRoot expects - it threw React
// #418 and fell back to a client render anyway, just noisily.
//
// On a pre-rendered *lazy* route we must wait for that route's chunk first.
// createRoot empties the container as soon as it runs, and Suspense would then
// show its blank fallback until the chunk arrived: the content appeared at
// ~0.5s, disappeared, and returned at ~2s. Waiting keeps the pre-rendered
// markup on screen until React can replace it with the real page in one go.
const isPreRendered = container.hasChildNodes();
const pendingRoute = isPreRendered
  ? routeLoaders[window.location.pathname]
  : undefined;

if (pendingRoute) {
  pendingRoute().then(mount, mount); // mount anyway if the chunk fails
} else {
  mount();
}

reportWebVitals();
